import { render, staticRenderFns } from "./DImage.vue?vue&type=template&id=5e335308&"
import script from "./DImage.vue?vue&type=script&lang=js&"
export * from "./DImage.vue?vue&type=script&lang=js&"
import style0 from "./DImage.vue?vue&type=style&index=0&id=5e335308&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports